module.exports = __webpack_public_path__ + "img/pd-img-face3.87714744.png";